(function () {
    var tn = 'ACC_SCS_Global_18';

    function runAt(selector, callback) {
        function tryFind() {
            var el = document.querySelector(selector);
            if (el) {
                callback([el]);
                return true;
            }
            return false;
        }
        if (tryFind()) return;
        var observer = new MutationObserver(function () {
            if (tryFind()) observer.disconnect();
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    function addContentIconLinks(anchor) {
        if (document.querySelector('.' + tn + '-content-wrapper')) return;

        anchor.insertAdjacentHTML('afterend',
            '<div class="' + tn + '-content-wrapper">' +
              '<div class="' + tn + '-content-wrapper-inner">' +
                '<a href="/products/luxury-seat-covers" class="' + tn + '-content-link">' +
                  '<div class="' + tn + '-content-item-icon ' + tn + '-content-item-icon-1">&nbsp;</div>' +
                  '<div class="' + tn + '-content-text">Seat covers</div>' +
                '</a>' +
                '<a href="/products/steering-wheel-cover" class="' + tn + '-content-link">' +
                  '<div class="' + tn + '-content-item-icon ' + tn + '-content-item-icon-2">&nbsp;</div>' +
                  '<div class="' + tn + '-content-text">steering wheel covers</div>' +
                '</a>' +
                '<a href="/products/petsuite-hard-bottom-dog-seat-protector-no-fur" class="' + tn + '-content-link">' +
                  '<div class="' + tn + '-content-item-icon ' + tn + '-content-item-icon-3">&nbsp;</div>' +
                  '<div class="' + tn + '-content-text">pet seat covers</div>' +
                '</a>' +
              '</div>' +
            '</div>'
        );
    }

    function checkAndAddContentIconLinks() {
        if (window.matchMedia('(max-width: 989px)').matches) {
            runAt('.header-wrapper > .header', function (els) {
                addContentIconLinks(els[0]);
            });
        }
    }

    function init() {
        checkAndAddContentIconLinks();
        var mediaQuery = window.matchMedia('(max-width: 989px)');
        mediaQuery.addEventListener('change', checkAndAddContentIconLinks);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
